import 'react-bootstrap-typeahead/css/Typeahead.css';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.scss'
import App from './App.tsx'
import { Provider } from 'react-redux';
import Store from './ReduxToolkit/Store';
import {SweetAlertProvider } from './Context/SweetAlertContext'
// import './i18n'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
     <Provider store={Store}>
     <SweetAlertProvider>
    <App />
    </SweetAlertProvider>
    </Provider>
  </StrictMode>,
)
